import { useQuery } from '@tanstack/react-query';
import { getPlateTransferEligibility } from '../requests/plateTransfer.request';

export const plateTransferEligibilityKey = (plateId?: string) => [
  'plate-transfer-eligibility',
  plateId
];

export const usePlateTransferEligibilityQuery = (plateId?: string, enabled = true) => {
  return useQuery({
    queryKey: plateTransferEligibilityKey(plateId),
    queryFn: () => getPlateTransferEligibility(plateId as string),
    enabled: !!plateId && enabled,
    // Tickets can be imported at any moment; always re-check when the dialog opens.
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false
  });
};
